import { render, staticRenderFns } from "./bidODM.vue?vue&type=template&id=352534d5&scoped=true&"
import script from "./bidODM.vue?vue&type=script&lang=js&"
export * from "./bidODM.vue?vue&type=script&lang=js&"
import style0 from "./bidODM.vue?vue&type=style&index=0&id=352534d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352534d5",
  null
  
)

export default component.exports